import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import OutlinedDASymbol from '../OutlinedDASymbol';
import s from './LoadingIndicator.scss';
var defaultProps = {
    view: 'spinner',
    coverMode: false,
    withOverlay: false,
};
var LoadingIndicator = /** @class */ (function (_super) {
    tslib_1.__extends(LoadingIndicator, _super);
    function LoadingIndicator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingIndicator.prototype.render = function () {
        var props = this.props;
        return (React.createElement("div", { className: classnames(s['root'], s["view-" + props.view], props.coverMode && s['cover-mode'], props.withOverlay && s['with-overlay'], props.className) }, {
            daSymbol: React.createElement(OutlinedDASymbol, null),
            daSymbolPurple: React.createElement(OutlinedDASymbol, { palette: "purple" }),
            watchSuggestions: React.createElement(OutlinedDASymbol, { palette: "green-to-purple" }),
            llama: React.createElement("div", { className: s['llama'] }),
            spinner: React.createElement("div", { className: s['spinner'] }),
        }[props.view]));
    };
    LoadingIndicator.defaultProps = defaultProps;
    return LoadingIndicator;
}(React.Component));
export default LoadingIndicator;
//# sourceMappingURL=LoadingIndicator.js.map